import React from "react";
import { Button } from "@mui/material";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";

const AddButton = ({
  label,
  color = "primary",
  variant = "contained",
  startIcon = <AddCommentOutlinedIcon />,
  onClick,
  disabled = false,
  sx = {},
  ...props
}) => {
  return (
    <Button
      color={color}
      variant={variant}
      onClick={onClick}
      startIcon={startIcon}
      disabled={disabled}
      {...props}
      sx={{
        py: 1.25,
        px: 4,
        borderRadius: '12px',
        background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
        boxShadow: '0 4px 14px 0 rgba(99, 102, 241, 0.39)',
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 6px 20px rgba(99, 102, 241, 0.45)',
          background: 'linear-gradient(135deg, #818cf8 0%, #6366f1 100%)',
        },
        ...sx
      }}
    >
      {label}
    </Button>
  );
};

export default AddButton;
